import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  action?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  backTo,
  backLabel,
  action
}: PageHeaderProps) {
  return <div className="mb-6" data-id="element-205">
      {backTo && <Link to={backTo} className="inline-flex items-center gap-1 text-sm font-semibold text-navy-500 hover:text-gold-600 mb-3 transition-colors" data-id="element-206">
          <ChevronLeft className="w-4 h-4" data-id="element-207" />
          {backLabel || 'Back'}
        </Link>}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-id="element-208">
        <div data-id="element-209">
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900" data-id="element-210">
            {title}
          </h1>
          {subtitle && <p className="text-navy-500 text-sm mt-1" data-id="element-211">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0" data-id="element-212">{action}</div>}
      </div>
    </div>;
}